// extracted by mini-css-extract-plugin
export default {"mapContainer":"EventsMap_mapContainer__FQZ2b","map":"EventsMap_map__GwCHt","mapError":"EventsMap_mapError__WWWo+"};